var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vacations-chart", attrs: { "data-frame": _vm.frame } },
    [
      _c("c-tabs", {
        staticClass: "vacations-chart__frames",
        attrs: {
          active: _vm.frame,
          items: [
            {
              label: "Неделя",
              value: "week",
            },
            {
              label: "Месяц",
              value: "month",
            },
            {
              label: "Таймлайн",
              value: "timeline",
            },
          ],
        },
        on: { change: _vm.setFrame },
      }),
      _c(
        "div",
        { staticClass: "vacations-chart__group-by" },
        [
          _c("c-input", {
            attrs: {
              type: "select",
              items: [
                { value: "filials", label: "По филиалам" },
                { value: "posts", label: "По должностям" },
              ],
              clearable: true,
              placeholder: "Без группировки",
            },
            model: {
              value: _vm.groupBy,
              callback: function ($$v) {
                _vm.groupBy = $$v
              },
              expression: "groupBy",
            },
          }),
        ],
        1
      ),
      _c(
        "position-watcher",
        {
          attrs: { offset: true },
          model: {
            value: _vm.position,
            callback: function ($$v) {
              _vm.position = $$v
            },
            expression: "position",
          },
        },
        [
          _c("div", { staticClass: "vacations-chart__border" }, [
            _c(
              "div",
              { staticClass: "vacations-chart__container" },
              [
                _vm.frame !== "timeline"
                  ? _c("div", { staticClass: "vacations-chart__frame frame" }, [
                      _c("span", {
                        staticClass: "frame-text",
                        domProps: { innerHTML: _vm._s(_vm.frameText) },
                      }),
                      _vm.frame !== "timeline"
                        ? _c("div", { staticClass: "frame-controls" }, [
                            _c(
                              "button",
                              {
                                staticClass: "frame-control",
                                attrs: { disabled: !_vm.hasPrevFrame },
                                on: { click: _vm.prevFrame },
                              },
                              [
                                _c("svg-icon", {
                                  attrs: { name: "chevron-left", size: 14 },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "frame-control",
                                attrs: { disabled: !_vm.hasNextFrame },
                                on: { click: _vm.nextFrame },
                              },
                              [
                                _c("svg-icon", {
                                  attrs: { name: "chevron-right", size: 14 },
                                }),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _c(
                  "perfect-scrollbar",
                  {
                    ref: "scroll",
                    staticClass: "vacations-chart__scroll",
                    on: {
                      "ps-scroll-left": _vm.onScrollLeft,
                      "ps-scroll-right": _vm.onScrollRight,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "wrapper",
                        staticClass: "vacations-chart__wrapper",
                      },
                      [
                        _c(
                          "div",
                          {
                            ref: "header",
                            staticClass: "vacations-chart-header",
                            class: {
                              fixed: _vm.position.top === -1,
                            },
                            style: {
                              transform: `translateY(${
                                _vm.position.topOffset > 0
                                  ? _vm.position.topOffset - 2
                                  : 0
                              }px)`,
                            },
                          },
                          [
                            _c("div", {
                              ref: "offset",
                              staticClass: "vacations-chart-header__cell",
                            }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "vacations-chart-header__days calendar",
                              },
                              _vm._l(_vm.days, function (d, i) {
                                return _c(
                                  "div",
                                  {
                                    key: i,
                                    staticClass:
                                      "vacations-chart-header__day calendar-day",
                                    class: {
                                      "calendar-day--off": d.dayOff,
                                    },
                                    attrs: {
                                      "data-day": d.date.format("DD.MM.YYYY"),
                                      "data-month": d.date.format("M"),
                                      "data-date": d.date.format("D"),
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        " " + _vm._s(d.date.format("D")) + " "
                                      ),
                                      _vm.frame === "week"
                                        ? _c("span", {
                                            staticClass: "short-month",
                                            attrs: {
                                              "data-month": d.date.format("M"),
                                            },
                                          })
                                        : _vm._e(),
                                    ]),
                                    _vm.frame === "week"
                                      ? _c("span", {
                                          staticClass: "week-day",
                                          attrs: { "data-day": i + 1 },
                                        })
                                      : _vm._e(),
                                    _vm.frame === "timeline"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "calendar-month",
                                            style: {
                                              width: `${d.tillMonthEnd * 100}%`,
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "month",
                                              attrs: {
                                                "data-date": d.date.format("D"),
                                                "data-month":
                                                  d.date.format("M"),
                                                "data-year":
                                                  d.date.format("YYYY"),
                                              },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        ),
                        _vm.groupBy
                          ? [
                              !_vm.groupsLoading && !_vm.groups.length
                                ? _c(
                                    "div",
                                    { staticClass: "workers-list-message" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "workers-list-message__panel workers-list__empty",
                                        },
                                        [
                                          _vm._v(
                                            " За текущий период отпуска и больничные не найдены "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              !_vm.groupsLoading && !_vm.groups.length
                                ? _c(
                                    "div",
                                    { staticClass: "workers-list-message" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "workers-list-message__panel workers-list__loading",
                                        },
                                        [
                                          _vm.groupsLoading
                                            ? _c("Loader")
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._l(_vm.groups, function (group) {
                                return _c("workers-group", {
                                  key: group.id,
                                  ref: "groups",
                                  refInFor: true,
                                  attrs: {
                                    group: group,
                                    days: _vm.days,
                                    frame: _vm.frame !== "timeline",
                                    "group-by":
                                      _vm.groupBy.value === "filials"
                                        ? "filial_id"
                                        : "post_code",
                                    "search-params": _vm.searchParams,
                                    "can-edit": _vm.canEdit,
                                    "show-all": !_vm.searchParams.periodStart,
                                  },
                                })
                              }),
                            ]
                          : [
                              _c("workers-list", {
                                ref: "list",
                                attrs: {
                                  days: _vm.days,
                                  frame: _vm.frame !== "timeline",
                                  "can-edit": _vm.canEdit,
                                  "show-all": !_vm.searchParams.periodStart,
                                },
                              }),
                            ],
                      ],
                      2
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }